import React, { useState } from 'react';
import { API, authFetch } from '../utils/api';
import CustomModal from './CustomModal';

function UploadPopup({car,onClose,onDone}){
  var[file,setFile]=useState(null);var[docType,setDocType]=useState('malso');var[loading,setLoading]=useState(false);
  var[modal,setModal]=useState(null);
  var closeModal=function(){setModal(null)};
  var docOptions=[
    {k:'malso',l:'📄 말소증명서',need:'말소신청'},
    {k:'myunjang',l:'📋 수출면장',need:'면장신청'},
    {k:'etc',l:'📎 기타서류',need:null}
  ];
  var up=function(){
    if(!file){setModal({type:'danger',title:'실패',message:'파일을 선택하세요',hideCancel:true,onConfirm:closeModal});return;}
    setLoading(true);
    var fd=new FormData();fd.append('file',file);fd.append('docType',docType);
    authFetch(API+'/cars/'+car.id+'/upload',{method:'POST',body:fd})
      .then(function(r){return r.json()})
      .then(function(d){
        setLoading(false);
        if(d.success){
          onDone(d.newStatus, d.docName, d.matchedBy);
        } else if(d.mismatch){
          setModal({type:'danger',title:'차량 정보 불일치',message:'업로드 문서: 차량번호 ['+d.extracted.carNo+'] / 차대번호 ['+d.extracted.vin+']\n등록 차량: 차량번호 ['+d.expected.carNo+'] / 차대번호 ['+d.expected.vin+']\n\n올바른 차량의 서류를 업로드하세요.',hideCancel:true,onConfirm:closeModal});
        } else {
          setModal({type:'danger',title:'실패',message:'업로드 실패: '+(d.error||'알 수 없는 오류'),hideCancel:true,onConfirm:closeModal});
        }
      }).catch(function(){setLoading(false);setModal({type:'danger',title:'실패',message:'서버오류',hideCancel:true,onConfirm:closeModal});});
  };
  return(
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center'}} onClick={onClose}>
      <div style={{background:'#fff',borderRadius:16,padding:28,width:380,boxShadow:'0 20px 60px rgba(0,0,0,0.3)'}} onClick={function(e){e.stopPropagation()}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20}}>
          <h3 style={{margin:0}}>📎 서류 업로드</h3>
          <button onClick={onClose} style={{background:'none',border:'none',fontSize:20,cursor:'pointer',color:'#94a3b8'}}>×</button>
        </div>
        <div style={{background:'#f0f9ff',border:'1px solid #bae6fd',borderRadius:10,padding:10,marginBottom:16,fontSize:12}}>
          <b>🚗 {car.carNo}</b> · {car.owner} · 현재: <b style={{color:'#2563eb'}}>{car.status}</b>
        </div>
        <div style={{marginBottom:16}}>
          <label style={{fontSize:12,fontWeight:600,color:'#64748b',display:'block',marginBottom:8}}>서류 종류</label>
          {docOptions.map(function(d){
            var canAuto=d.need&&car.status===d.need;
            return(
              <div key={d.k} onClick={function(){setDocType(d.k)}} style={{padding:'10px 14px',border:'2px solid '+(docType===d.k?'#3b82f6':'#e2e8f0'),borderRadius:10,marginBottom:6,cursor:'pointer',background:docType===d.k?'#eff6ff':'#fff',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <span style={{fontWeight:600,fontSize:13}}>{d.l}</span>
                {canAuto&&<span style={{fontSize:10,background:'#dcfce7',color:'#16a34a',padding:'2px 8px',borderRadius:10,fontWeight:700}}>자동 단계진입</span>}
                {d.need&&!canAuto&&<span style={{fontSize:10,color:'#94a3b8'}}>{d.need} 단계에서 자동진입</span>}
              </div>
            );
          })}
        </div>
        <div style={{marginBottom:16}}>
          <label style={{fontSize:12,fontWeight:600,color:'#64748b',display:'block',marginBottom:8}}>파일 선택</label>
          <input type="file" accept="image/*,.pdf" onChange={function(e){setFile(e.target.files[0])}} style={{width:'100%',padding:'8px',border:'1px solid #d0d5dd',borderRadius:8,fontSize:12}}/>
          {file&&<div style={{marginTop:6,fontSize:11,color:'#16a34a'}}>✅ {file.name}</div>}
        </div>
        <button onClick={up} disabled={loading} style={{width:'100%',padding:'12px',background:loading?'#94a3b8':'#3b82f6',color:'#fff',border:'none',borderRadius:10,fontSize:14,fontWeight:700,cursor:loading?'default':'pointer'}}>
          {loading?'⏳ 업로드 중...':'📤 업로드'}
        </button>
      </div>
      {modal&&<CustomModal isOpen={true} {...modal} onCancel={closeModal}/>}
    </div>
  );
}

export default UploadPopup;
